import actionTypes from './actionTypes';
import SharedSource from '../../sources/shared';
import translations from '../../translations';
import { addNotification } from './notification';
import { assocPath, pickBy } from 'ramda';

const ELEMENT_TYPE = 'page';

const generateNestedContainers = (flattenedPageContainers, parent) => {
    const containersNested = [];
    flattenedPageContainers.forEach((pageContainer) => {
        if (pageContainer.parentId === parent) {
            const children = generateNestedContainers(
                flattenedPageContainers,
                pageContainer.id,
            );

            const containerWithChildren = assocPath(
                ['pageContainers'],
                children.length ? children : null,
                pageContainer,
            );

            // Getting rid of the parentId key value
            const isParent = (val, key) => key !== 'parentId';
            const formattedContainer = pickBy(isParent, containerWithChildren);
            containersNested.push(formattedContainer);
        }
    });

    return containersNested;
};

export const savePage = (authenticationToken, tenantId) => async (dispatch, getState) => {
    const { pageEditor } = getState();
    const { pageContainers } = pageEditor;

    // We need to always start with the root container
    const root = pageContainers.find(
        childContainer => childContainer.parentId === null,
    );

    const nestedPageContainers = generateNestedContainers(
        pageContainers,
        root.parentId,
    );

    const pageWithNestedContainers = assocPath(
        ['pageContainers'],
        nestedPageContainers,
        pageEditor,
    );

    try {
        await SharedSource.save(
            pageWithNestedContainers,
            ELEMENT_TYPE,
            tenantId,
            authenticationToken,
        );

        dispatch(addNotification({
            type: 'success',
            message: translations['page save success'],
        }));

    } catch (error) {
        dispatch(addNotification({
            type: 'error',
            message: error.message,
            isPersistent: true,
        }));
    }
};

export const fetchPage = (authenticationToken, pageId) => async (dispatch) => {

    const flattendContainers = [];

    const page = await SharedSource.get(
        pageId,
        ELEMENT_TYPE,
        authenticationToken,
    );

    const pageMetaData = JSON.parse(page);

    const flattenPageContainers = (containers, parentContainerId = null) => {
        containers.forEach((container) => {
            if (container.pageContainers) {
                flattenPageContainers(
                    container.pageContainers,
                    container.id,
                );
            }

            // Inclusion of nested containers
            // would cause data duplication
            delete container.pageContainers;

            // The parent container ID is used as a foreign key
            container.parentId = parentContainerId;
            container.isActive = false;
            flattendContainers.push(container);
        });
    };

    flattenPageContainers(pageMetaData.pageContainers);

    pageMetaData.pageContainers = flattendContainers;

    dispatch({
        type: actionTypes.PAGE_SET,
        payload: {
            ...pageMetaData,
        },
    });
};

export const removePageContainer = containerId => ({
    type: actionTypes.PAGE_CONTAINER_REMOVE,
    payload: {
        containerId,
    },
});

export const setActivePageContainer = containerId => ({
    type: actionTypes.PAGE_CONTAINER_SET_ACTIVE,
    payload: {
        containerId,
    },
});

export const onPageContainerDrop = (containerId, parent, order, type) => ({
    type: actionTypes.PAGE_CONTAINER_DROP,
    payload: {
        containerId,
        parent,
        order,
        type,
    },
});
